import { GraphQLClient, Variables } from "graphql-request";
import { appConfig } from "../config";
import { DocumentNode } from "graphql";
import { eventBus } from "./event";
import { refreshAccessToken } from "./customHeader";

const endpoint = appConfig.api.graphQL;
let accessToken: string | null = localStorage.getItem("accessToken");
if (accessToken) {
  accessToken = JSON.parse(accessToken);
}
class CustomGraphQLClient extends GraphQLClient {
  private hasEmittedLogout: boolean; // Local variable to track event emission
  private isRefreshing: boolean;
  private failedQueue: Array<{ resolve: Function; reject: Function }>;

  constructor(endpoint: string, options?: any) {
    super(endpoint, options);
    this.hasEmittedLogout = false; // Initialize the variable in the constructor

    this.isRefreshing = false;
    this.failedQueue = [];
  }

  async request<T = any, V = Variables>(
    query: string | DocumentNode,
    variables?: V
  ): Promise<T> {
    try {
      return await super.request<T, V>(query, variables);
    } catch (error: any) {
      const { response } = error || {};
      const isUnauthorized = response?.errors?.[0].message === "Unauthorized";

      // check if the user is unauthorized
      if (isUnauthorized) {
        // if not unauthorized check if the refresh token is currently been tried to refresh
        if (this.isRefreshing) {
            // if trying to refresh the token, add the request to a failed queue that will be retried once refresh token is  
          return new Promise((resolve, reject) => {
            this.failedQueue.push({ resolve, reject });
          }).then((token) => {
            // once the token is accessToken is set, a retry happens
            return super.request<T, V>(query, variables);
          });
        }
        // if is refreshing access token is not happening, set to true
        this.isRefreshing = true;

        try {
          // refresh the access token
          const newAccessToken = await refreshAccessToken({
            // if on refresh something goes wrong - log the user out
            onNoRefreshTokenError: () => {
              this.logoutEmission();
            },
          });
          this.setHeader("authorization", `Bearer ${newAccessToken}`);
           // start processing failed queue since the access token is not updated
          this.processQueue(null, newAccessToken);

          return super.request<T, V>(query, variables);
        } catch (refreshError: any) {
          // if the refresh token  has expired log the user out 
          const isUnauthorized =
            refreshError?.response?.errors?.[0].message === "Unauthorized";
          if (isUnauthorized) {
            this.logoutEmission();
          }

          this.processQueue(refreshError, null);
          console.log("----refreshError----", refreshError)
        } finally {
          this.isRefreshing = false;
        }
      }

      throw error;
    }
  }

  logoutEmission() {
    if (!this.hasEmittedLogout) {
      eventBus.emit("logout");
      this.hasEmittedLogout = true;
    }
  }

  private processQueue(error: any, token: string | null = null) {
    this.failedQueue.forEach((promise) => {
      if (token) {
        promise.resolve(token);
      } else {
        promise.reject(error);
      }
    });
    this.failedQueue = [];
  }
}

const graphQLClient = new CustomGraphQLClient(endpoint, {
  headers: {
    "X-GAIN-APPNAME": "learnpad",
    authorization: `Bearer ${accessToken}`,
  },
});

export default graphQLClient;
